export default __webpack_public_path__ + "static/CBJLogoBLOCKWht-7c90216c5b087042b5d1d036ddc55a50.png";